export type RazaPrintPaperSize = "A4" | "A5" | "A5_ROTATED";

export const DEFAULT_RAZA_PRINT_PAPER_SIZE: RazaPrintPaperSize = "A4";

export const RAZA_PRINT_PAPER_SIZE_OPTIONS: Array<{
  id: RazaPrintPaperSize;
  name: string;
}> = [
  { id: "A4", name: "A4" },
  { id: "A5", name: "A5" },
  { id: "A5_ROTATED", name: "A5 (Rotated 90°)" },
];

export function resolveRazaPrintPaperSize(value?: string | null): RazaPrintPaperSize {
  const trimmed = value?.trim().toUpperCase();
  if (trimmed === "A5") return "A5";
  if (trimmed === "A5_ROTATED" || trimmed === "A5_ROTATED_90") return "A5_ROTATED";
  return DEFAULT_RAZA_PRINT_PAPER_SIZE;
}

/** Spacing / density for raza hardcopy; A4 matches current print, A5 is compact. */
export type RazaPrintLayout = {
  paperSize: RazaPrintPaperSize;
  /** Print sheet content width (A4 portrait / A5 portrait). */
  widthMm: 210 | 148;
  /** Whether 90 degree counter-clockwise rotation is applied. */
  isRotated?: boolean;
  /** Classes on the print root (`main-div` shared with receipt-layout base styles). */
  rootClassName: string;
  /** Outer Box `p` (MUI spacing units). */
  padding: number;
  /** Field row `mb` (MUI spacing units). */
  fieldMb: number;
  /** Schedule block `mt` (MUI spacing units). */
  scheduleMt: number;
  cellFontSizePx: number;
  stampSizePx: number;
  signatureMinHeightPx: number;
};

const A4_LAYOUT: RazaPrintLayout = {
  paperSize: "A4",
  widthMm: 210,
  rootClassName: "raza-unified-print raza-unified-print--a4 main-div",
  padding: 2,
  fieldMb: 2,
  scheduleMt: 3,
  cellFontSizePx: 16,
  stampSizePx: 250,
  signatureMinHeightPx: 250,
};

const A5_LAYOUT: RazaPrintLayout = {
  paperSize: "A5",
  widthMm: 148,
  rootClassName: "raza-unified-print raza-unified-print--a5 main-div",
  padding: 1,
  fieldMb: 1,
  scheduleMt: 1.5,
  cellFontSizePx: 12,
  stampSizePx: 100,
  signatureMinHeightPx: 100,
};

const A5_ROTATED_LAYOUT: RazaPrintLayout = {
  paperSize: "A5_ROTATED",
  widthMm: 148,
  isRotated: true,
  rootClassName:
    "raza-unified-print raza-unified-print--a5 raza-unified-print--a5-rotated main-div",
  padding: 1,
  fieldMb: 1,
  scheduleMt: 1.5,
  cellFontSizePx: 12,
  stampSizePx: 100,
  signatureMinHeightPx: 100,
};

export function getRazaPrintLayout(value?: string | null): RazaPrintLayout {
  const resolved = resolveRazaPrintPaperSize(value);
  if (resolved === "A5_ROTATED") return A5_ROTATED_LAYOUT;
  if (resolved === "A5") return A5_LAYOUT;
  return A4_LAYOUT;
}
